/* ET - USP Cards — mobile-only Swiper init

   Swiper ships with the theme as et-swiper.min.js, loaded just before this file, so both are deferred and
   execute in document order. Unlike the other ET sliders this one only runs at the mobile breakpoint: from
   990px up the cards are a plain flex row, so the instance is created on entering the media query and
   destroyed on leaving it. Everything is scoped to a section root, which lets several USP Cards sections
   live on one page and each drive its own Swiper and its own indicator. */

(function () {
  'use strict';

  if (window.__etUspCardsInit) return;
  window.__etUspCardsInit = true;

  var ROOT_SELECTOR = '[data-et-usp-cards]';
  var SWIPER_SELECTOR = '[data-et-usp-swiper]';
  var SCROLLBAR_SELECTOR = '[data-et-usp-scrollbar]';
  var CARD_SELECTOR = '.et-usp-cards__card';

  /* The single source of truth for "are we in slider territory" — it mirrors the 749px breakpoint the
     stylesheet uses, and drives both directions of the switch. */
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  /* In the theme editor a section can be injected after the deferred bundle has already run, and on a cold
     first paint the bundle may not have executed yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function cards(root) {
    return Array.prototype.slice.call(root.querySelectorAll(CARD_SELECTOR));
  }

  /* destroy(true, true) cleans Swiper's inline transforms and widths off the track and the slides, which is
     exactly what the desktop flex row needs — but it clears the whole style attribute, and the per-block
     card colour lives there. The colour is mirrored on a data attribute so it can be written straight back. */
  function restoreCardColours(root) {
    cards(root).forEach(function (card) {
      var colour = card.dataset.etUspCardBg;
      if (colour) card.style.setProperty('--et-usp-card-bg', colour);
    });
  }

  function buildOptions(root) {
    var options = {
      /* One card per slide, filling the slide width — the 32px rhythm is Swiper's, matching the gap the
         pre-init fallback strip uses so the handover is invisible. */
      slidesPerView: 1,
      spaceBetween: 32,
      /* A lone card must not become a draggable slider; this also locks the indicator. */
      watchOverflow: true,
      threshold: 4,
      grabCursor: true,
      a11y: Object.assign({ enabled: true }, window.etSwiperA11y),
      /* Without this the arrow keys do nothing once the slider has focus, so cards 2 and 3 were
         unreachable for a keyboard user on mobile. */
      keyboard: { enabled: true }
    };

    var scrollbar = root.querySelector(SCROLLBAR_SELECTOR);
    if (scrollbar) options.scrollbar = { el: scrollbar, draggable: true };

    return options;
  }

  function createSwiper(root) {
    if (root.etSwiper) return;

    var el = root.querySelector(SWIPER_SELECTOR);
    if (!el) return;

    whenSwiperReady(function () {
      /* The viewport can leave the mobile range, or the section can be removed, while the vendor bundle
         is still loading — re-check rather than instantiate into a stale state. */
      if (root.etSwiper || !root.isConnected || !mobileQuery.matches) return;
      root.etSwiper = new window.Swiper(el, buildOptions(root));
    });
  }

  function destroySwiper(root) {
    if (!root.etSwiper) return;

    root.etSwiper.destroy(true, true);
    root.etSwiper = null;
    restoreCardColours(root);
  }

  /* The whole mode decision for one root, in one place: slider markup AND a mobile viewport. Stack roots
     never carry the swiper hooks, so they fall through to the destroy branch and stay untouched. */
  function sync(root) {
    if (mobileQuery.matches && root.dataset.etUspLayout === 'slider') {
      createSwiper(root);
    } else {
      destroySwiper(root);
    }
  }

  /* shopify:section:load hands us the section wrapper, and the root is a descendant of it — but the scope
     is tested too so the helper is safe whichever element it is handed. */
  function each(scope, fn) {
    var node = scope || document;
    if (node.matches && node.matches(ROOT_SELECTOR)) fn(node);
    Array.prototype.forEach.call(node.querySelectorAll(ROOT_SELECTOR), fn);
  }

  function boot(scope) {
    each(scope, sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  var onBreakpointChange = function () {
    each(document, sync);
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', onBreakpointChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(onBreakpointChange);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target, destroySwiper);
  });

  /* Bring the card the merchant just selected in the theme editor into view — only meaningful while a
     Swiper is actually running. */
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (!root || !root.etSwiper) return;

    var card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    var index = cards(root).indexOf(card);
    if (index > -1) root.etSwiper.slideTo(index, 400);
  });
})();
